module.exports = __webpack_public_path__ + "static/apple_splash_1536-7b44b9f18c176c566ac9b15efb570658.png";